module.exports = __webpack_public_path__ + "img/select-lang-btn.19c2194c.png";